export default __webpack_public_path__ + "static/media/delete-large.35153eac.svg";